export default "/images/microsoft_azure__page_heading.png";